<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useCallStore} from "../../../store/calls"
import {useModalStore} from "../../../store/modal"
import {useUserStore} from "../../../store/users"
import {useAuthStore} from "../../../store/auth"
import {computed, onMounted, ref} from "vue";

const options = []
const loading = ref(false)
const callStore = useCallStore()
const modalStore = useModalStore()
const userStore = useUserStore()
const is_assigned = ref(false)
const heading = computed(() => {
    if (is_assigned.value) {
        return `Call assigned.`
    } else {
        return callStore.call?.assignee_id ?  `Reassign call.` : `Assign call.`
    }
})
const description = computed(() =>
    is_assigned.value
        ? users.value.find(u => u.id === assigned_user.value).first_name
        : callStore.call?.assignee
    ? `Assigned to ${callStore.call.assignee.first_name}`
    : null
)
const users = ref([])
const assigned_user = ref()
const authStore = useAuthStore()
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin', 'internal-team-leader'].includes(authStore.user.roles[0].name))

const assignCall = async () => {
    loading.value = true
    await callStore.assignCall(modalStore.props.id, assigned_user.value)
    loading.value = false
    is_assigned.value = true
}

onMounted(async () => {
    loading.value = true
    await callStore.getCall(modalStore.props.id)
    loading.value = false
    await userStore.getAllUsers({all: false, role: 'internal-agent'});
    users.value = isAdmin.value ? userStore.users : [authStore.user]

    users.value.forEach(u => {
        options.push({
            value: u.id,
            label: `${u.first_name} ${u.last_name}`
        })
    })
})
</script>

<template>
<DefaultModalBase :description  :heading :icon="is_assigned ? 'check-all' : callStore.call?.assignee ? 'arrow-rotate' : 'user-single-add'" :loading :refresh="is_assigned">

    <div class="call-assign-container">
        <brand-button variant="secondary" v-if="is_assigned" @click="modalStore.close(true)">Done</brand-button>
        <brand-form-select :label="callStore.call?.assignee ?'Reassign to.' : 'Assign to.'" :options="options" v-model="assigned_user" v-if="!is_assigned"/>
        <brand-button @click="assignCall()" :disabled="!assigned_user" v-if="!is_assigned">{{callStore.call?.assignee ? "Reassign call" : "Assign call"}}</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
